export default __webpack_public_path__ + "static/tooltip-anatomy-light-61b13e7eba4f2460b2aaf9a70a49eb800d96ed88010d92ef71d177436f19429d.png";